import { useCallback, useEffect, useState } from "react";

const FAVORITES_KEY = "hl51:favorites";
const HISTORY_KEY = "hl51:history";

function readList(key: string): string[] {
  try {
    const raw = window.localStorage.getItem(key);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((item) => typeof item === "string") : [];
  } catch {
    return [];
  }
}

function writeList(key: string, value: string[]) {
  try {
    window.localStorage.setItem(key, JSON.stringify(value.slice(0, 30)));
  } catch {
    // Local demo storage can fail in private mode; the feature still works in memory.
  }
}

export function recordHistory(id: string) {
  const current = readList(HISTORY_KEY).filter((item) => item !== id);
  writeList(HISTORY_KEY, [id, ...current]);
}

export function getHistory(): string[] {
  return readList(HISTORY_KEY);
}

export default function useFavorites() {
  const [favorites, setFavorites] = useState<string[]>([]);

  useEffect(() => {
    setFavorites(readList(FAVORITES_KEY));
  }, []);

  const isFavorite = useCallback((id: string) => favorites.includes(id), [favorites]);

  const toggleFavorite = useCallback((id: string) => {
    let nextValue = false;
    setFavorites((prev) => {
      const exists = prev.includes(id);
      nextValue = !exists;
      const next = exists ? prev.filter((item) => item !== id) : [id, ...prev];
      writeList(FAVORITES_KEY, next);
      return next;
    });
    return nextValue;
  }, []);

  return { favorites, isFavorite, toggleFavorite };
}